export const CREATE_ANNOTATION_CONFIG_TOOL_NAME = "create_annotation_config";
export const UPDATE_ANNOTATION_CONFIG_TOOL_NAME = "update_annotation_config";

export const ANNOTATION_CONFIG_WRITE_REJECTED_MESSAGE =
  "The user rejected the proposed annotation config change, so nothing was written.";
